package floris.graphics.repo

import floris.graphics.NetworkingConfig
import floris.graphics.QueryOptions
import floris.graphics.deleteRequest
import floris.graphics.getRequest
import floris.graphics.models.NetworkResponse
import floris.graphics.models.domain.models.Category
import floris.graphics.models.domain.models.toCategory
import floris.graphics.models.dto.requests.category.CategoryDto
import floris.graphics.models.dto.requests.category.InsertCategory
import floris.graphics.models.dto.requests.category.UpdateCategory
import floris.graphics.models.dto.responses.ErrorResponse
import floris.graphics.postRequest
import floris.graphics.putRequest

object CategoryRepo {

    private val categoryUrl = "${NetworkingConfig.baseUrl}/api/v1/categories"

    suspend fun getCategories(queryOptions: QueryOptions = QueryOptions()): List<Category> {
        val url = categoryUrl
        val response: NetworkResponse<List<CategoryDto>, ErrorResponse> = getRequest(url, queryOptions, true)

        return when (response) {
            is NetworkResponse.Success -> response.body.map { it.toCategory() }
            else -> emptyList()
        }
    }

    suspend fun getCategory(categoryId: String): Category? {
        val url = "$categoryUrl/$categoryId"
        val response: NetworkResponse<CategoryDto, ErrorResponse> = getRequest(url, allowUnauthenticated = true)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCategory()
            else -> null
        }
    }

    suspend fun insertCategory(category: InsertCategory): Category? {
        val url = categoryUrl
        val response: NetworkResponse<CategoryDto, ErrorResponse> = postRequest(resource = url, body = category)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCategory()
            else -> null
        }
    }

    suspend fun updateCategory(categoryId: String, category: UpdateCategory): Category? {
        val url = "$categoryUrl/$categoryId"
        val response: NetworkResponse<CategoryDto, ErrorResponse> = putRequest(resource = url, body = category)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCategory()
            else -> null
        }
    }

    suspend fun deleteCategory(categoryId: String): Boolean {
        val url = "$categoryUrl/$categoryId"
        val response = deleteRequest(resource = url)

        return when (response) {
            is NetworkResponse.Success -> true
            else -> false
        }
    }
}
